import ImageStrapi, {
  ImageStrapiProps,
} from '@/components/atoms/Image/ImageStrapi';
import { useTranslation } from '@/lib/i18n/i18n.client';
import { Text } from '@/components/atoms/Text';

type Props = {
  icons: ImageStrapiProps[];
};

const MAX_VISIBLE_ICONS = 4;

export default function ProductCardUseCaseIcons({ icons }: Props) {
  const { texts } = useTranslation();

  const visibleIcons = icons.slice(0, MAX_VISIBLE_ICONS);
  const hasMoreIcons = icons.length > MAX_VISIBLE_ICONS;

  if (!visibleIcons.length) {
    return null;
  }

  return (
    <ul className='flex items-center gap-2'>
      {visibleIcons.map((icon, index) => (
        <li
          key={index}
          className='rounded-sm border border-gray-300 w-6 h-6 p-1'
        >
          <ImageStrapi block={{ ...icon }} />
        </li>
      ))}
      {hasMoreIcons && (
        <li>
          <Text
            color='gray-500'
            variant='body-s'
            classNames={{
              wrapper: 'dark:text-gray-dark-500',
            }}
          >
            {texts.product_cards.more}
          </Text>
        </li>
      )}
    </ul>
  );
}
